<app-email-form [emailForm]="configurationFormEmail" (loadFromTemplateClicked)="loadFromTemplate()"></app-email-form>
<ejs-dialog #loadTemplateDialog
            [isModal]="true"
            [showCloseIcon]="true"
            [visible]="false"
            (close)="cancelClicked()"
            (open)="onOpen($event)">
  <ng-template #header>
    {{'i18n.domain.export-configuration.configurations.forms.email.template-selector-title' | translate}}
  </ng-template>

  <ng-template #content>
    <app-email-templates-overview (rowSelected)="templateSelected($event)" (recordDoubleClick)="templateSelectedAndClose($event)"></app-email-templates-overview>
  </ng-template>

  <ng-template #footerTemplate>
    <ng-container>
      <button class="e-control e-btn e-lib e-primary e-flat" (click)="okClicked()" [disabled]="!selectedTemplate">{{'i18n.shared.ok' | translate}}</button>
      <button class="e-control e-btn e-lib e-flat" (click)="cancelClicked()">{{'i18n.shared.cancel' | translate}}</button>
    </ng-container>
  </ng-template>
</ejs-dialog>